/* eslint-disable import/prefer-default-export */
export function take(qty) {
  return function takeItems(items = []) {
    return items.slice(0, qty);
  };
}



// WEBPACK FOOTER //
// ./src/utils/arrayUtil.js